// Shared content + assets for the Employee 2 Employer brand site.

export const IMAGES = {
  logo: "https://i.postimg.cc/sXhBhsG1/Fiverr-LOGO.png",
  portrait:
    "https://customer-assets.emergentagent.com/job_the-shift-1/artifacts/ca6w2tix_ChatGPT%20Image%20Apr%2030%2C%202026%2C%2008_42_59%20PM.png",
  book: "https://customer-assets-jt897jd0.emergentagent.net/job_the-shift-1/artifacts/exhlqz7u_THE%20SHIFT%20OFFICAL%20BOOK%20COVER-TRANSPARENT.png",
  architecture:
    "https://images.unsplash.com/photo-1496865534669-25ec2a3a0fd3?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  mountains:
    "https://images.unsplash.com/photo-1540979388789-6cee28a1cdc9?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  craftsman:
    "https://images.pexels.com/photos/18947370/pexels-photo-18947370.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  sunrise:
    "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  foundation:
    "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  community:
    "https://images.unsplash.com/photo-1511632765486-a01980e01a18?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
};

// Distributed reader assets. When we move to R2/S3, only the URL changes.
export const ASSETS = {
  readerPreviewPdf:
    "https://customer-assets-jt897jd0.emergentagent.net/job_the-shift-1/artifacts/con36ldu_The%20Shift%20%E2%80%94%20Advance%20Reader%20Preview.pdf",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "The Shift", to: "/book" },
  { label: "The System", to: "/system" },
  { label: "Builders Circle", to: "/builders-circle" },
  { label: "Our Mission", to: "/philosophy" },
  { label: "About", to: "/about" },
];

export const BUILDER_ATTRIBUTES = [
  { title: "Character", desc: "The foundation everything else is built upon." },
  { title: "Purpose", desc: "A clear reason to move forward with intention." },
  { title: "Relationships", desc: "Strong bonds that hold weight over time." },
  { title: "Leadership", desc: "The ability to guide yourself and others well." },
  { title: "Stewardship", desc: "Caring wisely for what you've been trusted with." },
  { title: "Service", desc: "Excellence expressed through helping others." },
  { title: "Legacy", desc: "Something meaningful that outlives you." },
  { title: "Impact", desc: "Leaving the world better than you found it." },
];

export const LEARN_POINTS = [
  "Break free from the survival mindset",
  "Discover lasting purpose",
  "Build confidence through discipline",
  "Create value in every area of life",
  "Develop strong, grounded leadership",
  "Build healthy relationships",
  "Practice wise stewardship",
  "Serve others with excellence",
  "Leave a lasting legacy",
];

// Testimonials — the section auto-hides when this array is empty.
// Populate with real reader quotes once available.
export const TESTIMONIALS = [];
